import { FC, useMemo, useEffect } from "react"
import { useCustomerBrandCards } from "@ncs/ncs-api"
import {
	AnimatedEntrance,
	Divider,
	GridContainer,
	GridItem,
	GridItemProps,
	Heading,
	LoadingSpinner,
} from "@ncs/web-legos"
import { ShopBrandCtaEcomm } from "./ShopBrandCtaEcomm"
import { useAuth } from "@ncs/ncs-api"

export const BrandCtaGridEcomm: FC = () => {
	const { user } = useAuth()
	const [cards, cardsLoading, { query }] = useCustomerBrandCards()

	useEffect(() => {
		async function refetchCards(): Promise<void> {
			await query.refetch()
		}
		refetchCards().catch(console.error)
	}, [JSON.stringify(user), query.refetch])

	// Preload brand card images
	useEffect(() => {
		if (cards && cards.length > 0) {
			cards.forEach((card) => {
				const link = document.createElement("link")
				link.rel = "preload"
				link.as = "image"
				link.href = card.logoImageUrl
				document.head.appendChild(link)
			})
		}
	}, [cards])

	const gridItemProps: GridItemProps = useMemo(() => {
		if (!cards || !cards.length) {
			return {}
		}
		return {
			xs: 12,
			sm: 6,
			md: 4,
		}
	}, [cards])

	if (cardsLoading) {
		return (
			<GridContainer justifyContent="center" alignItems="center" minHeight="200px">
				<LoadingSpinner />
			</GridContainer>
		)
	}

	if (!cards || cards.length === 0) {
		return null
	}

	return (
		<>
			<Heading fontSize={1.5} mb={1} mt={1.5} bold>
				Our Catalogs
			</Heading>
			<GridContainer
				rowGap={3}
				columnGap={3}
				justifyContent="center"
				smProps={{ columnGap: 2 }}
				xsProps={{ columnGap: 0 }}
				minHeight={user ? "inherit" : "450px"}
			>
				{cards.map((card, i) => (
					<GridItem key={card.id} {...gridItemProps}>
						<AnimatedEntrance show delay={75 * i}>
							<ShopBrandCtaEcomm card={card} />
						</AnimatedEntrance>
					</GridItem>
				))}
			</GridContainer>

			<Divider my={3} />
		</>
	)
}
